import React, {useEffect, 
    // useRef, 
    useState} from 'react'
import styles from './styles.module.scss'
import {connect} from 'react-redux'
import {getMethPlanYears, getMethPlan_1, getMethPlan_2, getMethPlan_3, getMethPlan_4, getMethPlanTrash} from '../../actions/methodical_plan'
import Loader from 'react-loader';
import Selector from '../shared/Selector';
import PDF from './PDF';
import { store } from '../App';

const mapStateToProps = ({methodPlan}) => {
    const {years, meth_plan_1, meth_plan_2, meth_plan_3, meth_plan_4, loading} = methodPlan;
    return {years, meth_plan_1, meth_plan_2, meth_plan_3, meth_plan_4, loading}
}

const MethPlan = ({
    getMethPlanTrash,
    getMethPlanYears,
    years,
    getMethPlan_1,
    getMethPlan_2,
    getMethPlan_3,
    getMethPlan_4,
    meth_plan_1,
    meth_plan_2,
    meth_plan_3,
    meth_plan_4,
    loading
}) => {

    const [yearsLocal, setYearsLocal] = useState([]) // список годов
    const [year, setYear] = useState(null) // выбранный год
    const [isPopup, setIsPopup] = useState(false) // отображение попапа
    const [file, setFile] = useState(null) // blob файла

    const gou = store.getState().layout.data.GOU_Name;
    const name = store.getState().auth.lastname;

    // const containerRef = useRef(null); // клик вне попапа

    // const handleClickOutside = (event) => { // клик вне попапа
    //     if (containerRef.current && !containerRef.current.contains(event.target)) {
    //         // setIsPopup(null);
    //     }
    // };

    // useEffect(() => { // клик вне попапа
    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, []);

    useEffect(() => {
        getMethPlanYears();
        return () => {
            getMethPlanTrash();
        }
    }, [])

    useEffect(() => {
        if (!years) {
            return
        }
        const newYears = years
            ?.map(({period, mpid}) => ({name: period, value: mpid})).reverse()
        setYearsLocal([...newYears])
    }, [years])

    useEffect(() => {
        if (!yearsLocal || yearsLocal
            ?.length === 0) {
            return
        }
        setYear(yearsLocal
            ?.[0]
                ?.value)
    }, [yearsLocal])

    const handleGetMethPlan = (year) => {
        getMethPlan_1(year)
        getMethPlan_2(year)
        getMethPlan_3(year)
        getMethPlan_4(year)
    }

    useEffect(() => { 
        setFile(null)
    }, [year])

    return ( <> <div className={styles.wrapper}>
        <p className={styles.title}>План методической деятельности вуза на учебный год</p>
        <div className={styles.panel}>
            <div className={styles.selectLeft}>
                <Selector
                    label='Учебный год'
                    width='300px'
                    options={[...yearsLocal]}
                    onChange={(e) => setYear(e)}
                    value={year}/>
            </div>

            <div className={styles.selectRight}>
                {!loading && meth_plan_1 && meth_plan_2 && meth_plan_3 && <PDF
                    name={name}
                    gou={gou}
                    meth_plan_1={meth_plan_1}
                    meth_plan_2={meth_plan_2}
                    meth_plan_3={meth_plan_3}
                    meth_plan_4={meth_plan_4}
                    setFile={setFile}
                    file={file}
                    year={yearsLocal.find(el => el.value == year)?.name}
                    setIsPopup={setIsPopup}/>}
                <div className={styles.button} onClick={() => handleGetMethPlan(year)}>Обновить</div>
            </div>
        </div>

        {file && <div className={styles.pdf}>
            <iframe
                // ref={containerRef}
                src={URL.createObjectURL(file)}
                width="100%"
                height="100%"></iframe>
        </div>}

        <Loader loaded={!loading} color='grey'/>
    </div> </>
  )
}

export default connect(mapStateToProps, {
    getMethPlanYears, 
    getMethPlan_1, 
    getMethPlan_2,
    getMethPlan_3,
    getMethPlan_4,
    getMethPlanTrash
})(MethPlan)